import vueUIInitiator from './vue-ui-initiator';
import MySelect from '../vue-components/MySelect';

const ELEMENTS_NAV = {
    wrapper: '.menu__wrapper',
    wrapperHiddenClassName: 'lg-hidden',
    nav: '[data-scroller]',
    links: '.js--nav-link',
    tmplTab: '#tab-more',
    hideClassName: 'd-none',
};

function showWrapper() {
    setTimeout(() => {
        const wrapper = document.querySelector(`.${ELEMENTS_NAV.wrapperHiddenClassName}`);
        wrapper.classList.remove(ELEMENTS_NAV.wrapperHiddenClassName);
    }, 100);
}
function mainNav() {
    const wrapper = document.querySelector(ELEMENTS_NAV.wrapper);
    const nav = document.querySelector(ELEMENTS_NAV.nav);
    if (!nav || !wrapper) { return false; }

    const wrapperWidth = wrapper.offsetWidth;
    const navWidth = nav.offsetWidth;

    showWrapper();

    if (navWidth > wrapperWidth * 0.85) {
        const links = nav.querySelectorAll(ELEMENTS_NAV.links);

        for (let i = 0; i < links.length; i++) {
            const currentIdx = links.length - (i + 1);
            links[currentIdx].classList.add(ELEMENTS_NAV.hideClassName);

            const newWidth = nav.offsetWidth;
            if (newWidth < wrapperWidth * 0.85) {
                const tmpl = document.querySelector(ELEMENTS_NAV.tmplTab);

                nav.append(tmpl.content.cloneNode(true));
                nav.setAttribute('data-show-tabs', `${currentIdx}`);
                vueUIInitiator('js--select-more', MySelect, 'my-select');
                return false;
            }
        }
    }
}

export default mainNav;
